var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "g-inline-promotion g-layout__item" }, [
    _c("div", {
      staticClass: "g-inline-promotion__inner",
      domProps: { innerHTML: _vm._s(_vm.result.content) },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }